import { lazy, Suspense } from "react";
import { Navigate, RouteObject } from "react-router-dom";

import { LoadingSkeleton } from "@narmi/design_system";

import { PermissionedRoutes } from "../../components/PermissionedRoutes";

const ConversionsDashboardPage = lazy(() =>
  import("./ConversionsDashboard").then((module) => ({ default: module.ConversionsDashboardPage }))
);

const ConversionDataViewer = lazy(() =>
  import("./ConversionDataViewer").then((module) => ({ default: module.ConversionDataViewer }))
);

export const CONVERSIONS_ROUTES: RouteObject[] = [
  {
    element: (
      <PermissionedRoutes requiredFeatures={["conversions_dashboard"]} requiredRoles={["narmi"]} />
    ),
    children: [
      {
        index: true,
        element: <Navigate to="staged" />,
      },
      {
        path: ":statusTab/:id?",
        element: (
          <Suspense fallback={<LoadingSkeleton isLoading />}>
            <ConversionsDashboardPage />
          </Suspense>
        ),
      },
      {
        path: "import_job_units",
        element: (
          <Suspense fallback={<LoadingSkeleton isLoading />}>
            <ConversionDataViewer />
          </Suspense>
        ),
      },
    ],
  },
];
